import * as React from 'react';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';

class Day extends React.Component {

	constructor(props)	{
		super(props);
		this.state = {
			notes : this.props.Notes,
			value: ''
		}
	}

	// Made to add a placeholder for the first of the month
	addANote(i) {if(i===0){return"Add a note"}}

	addTheNote(date,el) {
		const notes = this.state.notes;
		notes.push({date: date,note: el});
		this.setState({	notes: notes }, () => this.props.onAddNote(this.state.notes) );
		this.setState({ value: "" });
	}

	LNotes(date){
		const ListNotes = [];
		this.state.notes.forEach( (note, index) => {
			if (note.date === date) (
				ListNotes.push(
					<Typography sx={{fontSize:14,overflowWrap:"break-word"}} key={index} gutterBottom>{note.note}</Typography>
				)
			)
		})
		return (
			<>
				{ListNotes}
			</>
		)
	}

	getTheDay(day,month,year){
		const months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
		const days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
		const theDay = new Date(months[month]+' '+day+', '+year+' 12:00:00');
		return( days[theDay.getDay()] );
	}



	render(){
		var date = this.props.data.day+"."+(this.props.data.month+1)+"."+this.props.data.year;
		return (
			<Grid item xs={6} sm={3} md={2}>
				<Card variant="outlined" date={date} sx={{height:"100%"}}>
					<CardContent>
						<Typography sx={{fontSize:14}} color="text.secondary" gutterBottom>{this.getTheDay(this.props.data.day,this.props.data.month,this.props.data.year)} {this.props.data.day}</Typography>
						{this.LNotes(date)}
						<Stack direction="row" spacing={0}>
							<TextField 
							sx={{m:0}} onChange={event => this.setState({value:event.target.value})}
							variant="standard" multiline value={this.state.value}
							/>
							<IconButton variant="outlined" sx={{width:"auto",m:"auto"}} onClick={() => this.addTheNote(date,this.state.value)}>
								<AddIcon/>
							</IconButton>
						</Stack>
					</CardContent>
				</Card>
			</Grid>
		);
	}


}

export default Day;